export default __webpack_public_path__ + "static/media/hamburger.4e407568.svg";